module.exports = __webpack_public_path__ + "static/media/20ECE10.3f3e071a.jpg";